import React, { useEffect } from "react";
import { useRouter } from "next/router";
import PrintTicketForm from "../components/tickets/PrintTicketForm"; // Adjust the path as necessary
import BugAnimation from "../components/BugAnimation";
import { useAxios } from "../http-client/AxiosContext";
import { hasScope } from "../auth/scopes";

const Home = () => {
  const { grantedScopes } = useAxios();
  const router = useRouter();
  const canDashboard = hasScope(grantedScopes, "read:dashboard");
  const canPrint = hasScope(grantedScopes, "read:printer");

  useEffect(() => {
    // Admins land on the dashboard; printer-only users keep the ticket form;
    // everyone else goes to their orders list.
    if (canDashboard) router.replace("/dashboard");
    else if (!canPrint) router.replace("/order");
  }, [canDashboard, canPrint, router]);

  if (canDashboard || !canPrint) return null;

  return (
    <>
      <BugAnimation />
      <div>
        <PrintTicketForm/>
      </div>
    </>
  );

};

export default Home;
